import React, { PureComponent } from 'react'
import { observer } from 'mobx-react'
import ModalHeader from '../../../UniformComponents/ModalHeader'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Checkbox from '../../form/Checkbox'
import Button from '../../../UniformComponents/Button'

@observer
class GettingStarted extends PureComponent {
    radioButton = (icon, title, subTitle, key) => {
        const { dashboardWizardStore } = this.props
        const { newWidget, setWidgetBasis } = dashboardWizardStore
        const { widgetBasis } = newWidget
        return (
            <div
                className={`largeRadio ${widgetBasis === key ? 'active' : ''}`}
                onClick={() => setWidgetBasis(key)}
                onKeyDown={() => setWidgetBasis(key)}
                role="button"
                tabIndex={0}
            >
                <div className="iconBox">
                    <div className="iconBorder">
                        <i className={icon} />
                    </div>
                </div>
                <div className="title">
                    {title}
                </div>
                <div className="subTitle">
                    {subTitle}
                </div>
                <Checkbox
                    name={key}
                    onBlur={(v) => setWidgetBasis(v.name)}
                    checked={widgetBasis === key}
                />
            </div>
        )
    }

    render() {
        const { dashboardWizardStore } = this.props
        const { toggleShow, nextStage } = dashboardWizardStore
        return (
            <div className="gettingStarted">
                <ModalHeader cssClass="header">
                    <div className="title">
                        Getting started...
                    </div>
                    <div className="subTitle">
                        Select your widget data option below
                    </div>
                </ModalHeader>
                <div className="body">
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        {this.radioButton(
                            'fa-light fa-chart-simple',
                            'Question based',
                            'Base the widget on data formed from question responses.',
                            'question',
                        )}
                        {this.radioButton(
                            'fa-light fa-chart-tree-map',
                            'Other measures',
                            'Base the widget on other measures not neccessarily formed of question responses.',
                            'other',
                        )}
                    </div>
                </div>
                <ModalFooter>
                    <Button
                        label="Cancel"
                        cssClass="tertiary regular"
                        style={{ marginRight: '25px', width: '134px' }}
                        onClick={toggleShow}
                    />
                    <Button
                        label="Continue"
                        cssClass="primary regular"
                        style={{ width: '134px' }}
                        onClick={nextStage}
                    />
                </ModalFooter>
            </div>
        )
    }
}

export default GettingStarted
